export default __webpack_public_path__ + "media/images/flags/pa-77fad70af9eec88cf79088cca9ed4946.png";